
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { SubscriptionManager } from "./SubscriptionManager";
import { PromoCodeInput } from "./PromoCodeInput";

export const BillingActions = ({ 
  onSuccess,
  isLoading,
  setIsLoading 
}: { 
  onSuccess: () => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}) => {
  const { toast } = useToast();
  const [promoCode, setPromoCode] = useState("");

  const handleSubscriptionManagement = async () => {
    try {
      setIsLoading(true);
      console.log('Starting subscription management');
      
      const { data, error } = await supabase.functions.invoke('create-portal-session', {
        body: {}
      });
      
      console.log('Checkout response:', { data, error });
      
      if (error) throw error;
      if (data?.url) {
        window.location.href = data.url;
      }
    } catch (error: any) {
      console.error('Detailed subscription management error:', error);
      toast({
        title: "Error",
        description: error.message || "Could not access subscription management",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
      onSuccess();
    }
  };

  const handleLifetimeUpgrade = async () => {
    try {
      setIsLoading(true);
      console.log('Starting lifetime upgrade');
      
      const { data, error } = await supabase.functions.invoke('create-checkout', {
        body: { 
          priceId: 'price_1Q8QzHCFL931KD1u55LEohO0',
          couponCode: promoCode || undefined
        }
      });
      
      console.log('Checkout response:', { data, error });
      
      if (error) throw error;
      if (data?.url) {
        window.location.href = data.url;
      }
    } catch (error: any) {
      console.error('Detailed lifetime upgrade error:', error);
      toast({
        title: "Error",
        description: error.message || "Could not process lifetime upgrade",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
      onSuccess();
    }
  };

  return (
    <div className="space-y-4">
      <SubscriptionManager />
      
      {/* Promo Code Section */}
      <div className="border rounded-lg p-4 bg-gray-50">
        <h3 className="font-medium mb-3">Have a promo code?</h3>
        <PromoCodeInput 
          onPromoCodeChange={setPromoCode}
          appliedCode={promoCode}
          isLoading={isLoading}
        />
      </div>

      <div className="flex flex-col gap-2">
        <Button 
          onClick={handleSubscriptionManagement}
          className="w-full bg-cso-600 hover:bg-cso-700"
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Manage Subscription"}
        </Button>
        <Button 
          onClick={handleLifetimeUpgrade}
          className="w-full bg-green-600 hover:bg-green-700"
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Upgrade to Lifetime"}
        </Button>
      </div>
    </div>
  );
};
